module.exports = __webpack_public_path__ + "img/images_homebanner_1_3.9befc841.png";